angular.module('unica_invitation_list.invitation_list_controllers')

.controller('InvitationListEditController', function(
	$rootScope, $scope, $state, $stateParams,
	InvitationListEditService
) {

	$rootScope.getInvitationList($stateParams.id);

	$scope.saveInvitationList = function() {
		$scope.showLoader();

		var invitationListData = angular.copy($rootScope.invitationListData);
		invitationListData = $scope.parseInvitationListToTimestamp(invitationListData);

		InvitationListEditService
			.update( invitationListData )
			.then(function(data) {
				$scope.hideLoader();
				if (!data.error) {
					$scope.showSuccessMsg('Tipologia Lista aggiornata con successo!', '');
				} else {
					$rootScope.manageError(data);
				}
			});
	};

})

;